import DOMPurify from 'dompurify';

DOMPurify.addHook('uponSanitizeElement', (node, data) => {
  if (data.tagName === 'a') {
    node.setAttribute('target', '_blank');
  }
  return node;
});

export const config = { ADD_ATTR: ['target'] };

export const cleanHTML = html => (
  DOMPurify.sanitize(html, config)
);
